// extracted by extract-css-chunks-webpack-plugin
module.exports = {"coverArt":"app-components-coverart--coverArt","auto":"app-components-coverart--auto","title":"app-components-coverart--title","image":"app-components-coverart--image"};